import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AcceleratorEnrollment } from '@interfaces';

export function getColumns(util: UtilityService) {
	const columns: GridColumn<AcceleratorEnrollment, unknown>[] = [
		buildColumn(util, 'Id', row => row.personId, { header: 'Person Id', hidden: true }),
		buildColumn(util, 'Text', row => row.name, { header: 'Name', width: 120 }),
		buildColumn(util, 'Text', row => row.courseTitle, { header: 'Course Title', width: 150 }),
		buildColumn(util, 'Id', row => row.courseVersionId, { header: 'Course Version Id', hidden: true }),
		buildColumn(util, 'Id', row => row.accId, { header: 'Acc Id', hidden: true }),
		buildColumn(util, 'Text', row => row.acceleratorName, { header: 'Accelerator', width: 120, group: 'asc' }),
		buildColumn(util, 'Percent', row => row.completionPercentage, { header: '% Complete', width: 80 }),
		buildColumn(util, 'Text', row => row.ventureStatus, { header: 'Venture Status' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Enrolled', width: 100 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', width: 100 }),
		buildColumn(util, 'Date', row => row.completedUTC ? util.date.fromUTC(row.completedUTC) : undefined, { header: 'Completed Date', width: 100 }),
	];
	return columns;
}
